import mixpanel from "mixpanel-browser";
import { useCallback } from "react";
import { MktVersionTypes } from "components/mkt/mktVersionUtils";

/**
 * Hook for setting Mixpanel People properties in the Promotion project.
 * This is for anonymous user property tracking without identification.
 */
export default function useMixpanelProfileMkt(version: MktVersionTypes) {
  return useCallback(
    (properties: { [key: string]: any }) => {
      try {
        let instance: any;

        if (version === "v3") {
          instance = (mixpanel as any).v3;
        } else if (version === "v4") {
          instance = (mixpanel as any).promotion;
        } else if (version === "v5") {
          instance = (mixpanel as any).v5;
        } else {
          return;
        }

        if (!instance) {
          console.error(`Mixpanel ${version} instance not found!`);
          return;
        }

        if (!instance.people) {
          console.error(`Mixpanel ${version} instance.people not found!`);
          return;
        }

        // Then set people properties with callback to confirm
        instance.people.set(properties, (response: any) => {
          if (response === 1 || response?.status === 1) {
          } else {
            console.error(
              "Failed to send people properties. Response:",
              response
            );
          }
        });
      } catch (error) {
        console.error("Error setting mixpanel people properties:", error);
      }
    },
    [version]
  );
}
